import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTierQuery = createQueryHook(MembershipsCreatorV2ApiClient.getTier, {
  queryKey: ['tier'],
})
